import {
    PRODUCTS_SALE_EDIT,
    PRODUCTS_SEARCH,
    PRODUCTS_SUCCESS_EDIT,
    PRODUCTS,
    ORDER_SELECT,
    UNSET_PRODUCTOS
  } from './productos.types';
  import * as fromProductos from './productos.actions'
  import { Productos } from '../../../../models/productos/productos.models';
import { ITurnosAsignados } from '../../../../models/turnos-asignados/turnos-asignados.interface';
import { Turnos } from '../../../../models/turnos/turnos.models';
  export interface ProductosState {
    productos: Productos,
    turnos: Turnos[]
    pedidosTurnos: any [],
    turno: 0,
    turnosAsignados: ITurnosAsignados
}

const initialState: ProductosState = {
    productos: null,
    turnos: [],
    pedidosTurnos: [],
    turno: 0,
    turnosAsignados: null
};
  export function productosReducer(state = initialState, action: fromProductos.acciones): ProductosState {
    switch (action.type) {
      case PRODUCTS:
        return manipularPedido(state, action);
      case ORDER_SELECT:
        return buscarPedido(state, action);
      case PRODUCTS_SUCCESS_EDIT:
        return actualizarProductos(state, action);
      case UNSET_PRODUCTOS:
        return {
          productos: null,
          turnos: [],
          pedidosTurnos: [],
          turno: 0,
          turnosAsignados: null
        };
      case PRODUCTS_SALE_EDIT:
        return actualizarVenta(state, action);
      case PRODUCTS_SEARCH:
        return buscarVenta(state, action);
      default:
        return state;
    }
  }
    
  const actualizarVenta = (state, action) => {
    return {
      ...state,
      [action.turnosAsignados[0]]: action.payload.turnos,
    };
  };
  
  const buscarVenta = (state, action) => {
    const turnoCadena = [`Turno-${action.payload.turno}`];
    for (let i = 0; i < state; i++) {}
    return { ...state, productosSeleccion: turnoCadena };
  };
  
  const actualizarProductos = (state, action) => {
    return { ...state, products: action.payload.products };
  };
  
  const manipularPedido = (state, action) => {
    const cantidadTurnosPedidos = action.turnosAsignados.length;
    let turno = action.turno
    let turnos = []
    let nuevaData = '';
    let nuevoArray = [];
    let producto = action.producto.filter(item => item.turno == action.turno )
    let productoCopia = action.producto.filter(item => item.turno != action.turno )
    const recorrerInicial =
    action.producto !== undefined && action.producto[0] !== undefined ? action.producto.length : 0;
    action.producto = null;
    
    const cadenaPedido = JSON.stringify(producto);
    let pedidoArray = [];
    if (recorrerInicial === 0) {
      nuevaData = `{"0":["Turno-${turno}",${cadenaPedido}]}`;
      nuevoArray = JSON.parse(nuevaData);
    } else {
      const turnoComparar = `Turno-${turno}`;
      let existe = false;
      for (let i = 0; i < 1; i++) {
        if (producto !== undefined) {
          const valor =  `Turno-${producto[0]["turno"]}`;
          if (valor == turnoComparar) {
            existe = true;
            const cade = `["Turno-${turno}",${cadenaPedido}]`;
            pedidoArray = JSON.parse(cade);
            if(action.producto === null ) {
              action.producto = pedidoArray;
            } else {
              action.producto(pedidoArray);
            }
          }
        }
      }
      if (!existe) {
        existe = false;
        nuevaData = `["Turno-${turno}",${cadenaPedido}]`;
        nuevoArray = JSON.parse(nuevaData);
        let nuevaPosicion = 1;
        for (let y = 0; y < action.turnosAsignados.length; y++) {
          if (state.pedidosTurnos[y] === undefined) {
            nuevaPosicion = y;
            y = action.turnosAsignados.length + 1;
          }
        }
        state.pedidosTurnos[nuevaPosicion] = nuevoArray;
      }
    }
  
    const data = action.producto === undefined ? nuevoArray : action.producto;
    
    return { ...state, pedidosTurnos: data };
  };
  
  const buscarPedido = (state, action) => {
    const recorrerInicial =
    action.producto[0] !== undefined ? action.producto[0].length : 0;
    const cantidadTurnosPedidos = action.payload.turnos.length;
    const { turno, turnos } = action.payload.turnos[cantidadTurnosPedidos - 1];
    const recorrer = turnos.length;
    let pedidoArray = [];
    let productosSeleccionActualizado = [];
    if (recorrerInicial === 0) {
      return { ...state, productosSeleccion: productosSeleccionActualizado };
    }
    const turnoComparar = `Turno-${turno}`;
    for (let i = 0; i < recorrer; i++) {
      if (action.producto !== undefined) {
        const valor = action.producto[i]
        if (valor === turnoComparar) {
          const cadena = JSON.stringify(action.producto[i])
          pedidoArray = JSON.parse(cadena);
          productosSeleccionActualizado = pedidoArray;
          i += recorrer;
        }
      }
    }
    const productosNuevos = handleUpdateProduct(
      productosSeleccionActualizado,
      state.products,
    );
    let productosNuevosValorReal = [];
    productosNuevosValorReal =
      productosNuevos.length === 0 ? state.products : productosNuevos;
    return {
      ...state,
      productosSeleccion: productosSeleccionActualizado,
      products: productosNuevosValorReal,
    };
  };
  
  export const handleUpdateProduct = (productosDescripcionDomicilios, productlist) => {
    let dataNueva = [];
    dataNueva = limpiarArray(productlist);
    for (let k = 0; k < productosDescripcionDomicilios.length; k++) {
      for (let i = 0; i < productlist.length; i++) {
        if (productosDescripcionDomicilios[k].rownumber === productlist[i].rownumber) {
          dataNueva[i].cantidad = productosDescripcionDomicilios[k].cantidad;
        }
      }
    }
    return dataNueva;
  };
  
  const limpiarArray = productlist => {
    const dataNueva = [];
    for (let i = 0; i < productlist.length; i++) {
      dataNueva.push({
        cantidad: 0,
        domiciliosAddGruposproductsContenidoId:
          productlist[i].domiciliosAddGruposproductsContenidoId,
        domiciliosAddgruposUuid: productlist[i].domiciliosAddgruposUuid,
        domiciliosAddproductsUuid: productlist[i].domiciliosAddproductsUuid,
        imagen: productlist[i].imagen,
        nombre: productlist[i].nombre,
        productosId: productlist[i].productosId,
        rownumber: productlist[i].rownumber,
        valorVenta: productlist[i].valorVenta,
        valoresAdicionales: productlist[i].valoresAdicionales,
        tipoProducto: productlist[i].tipoProducto,
        gruposProductosId:productlist[i].gruposProductosId,
        valorProducto:productlist[i].valorProducto,
        valorImpuesto:productlist[i].valorImpuesto,
        valorImpuestoCalculo:productlist[i].valorImpuestoCalculo,
        ubicacionesPorSalonesId:productlist[i].ubicacionesPorSalonesId,
      });
    }
    return dataNueva;
  };



// WEBPACK FOOTER //
// ./src/pages/meseromesero/state/productos/productos.reducer.ts